import { useEffect } from 'react';

import { APP } from '../i18n/el';

// P3-11: ο τίτλος της καρτέλας ακολουθεί τη σελίδα.
//
// Ήταν **σταθερός**, ο πλήρης τίτλος της εργασίας από το `index.html`, σε κάθε
// διαδρομή. Με ανοιχτές πολλές καρτέλες της ίδιας εφαρμογής —που είναι ο κανόνας
// όταν κανείς συγκρίνει δύο συλλογές— καμία δεν ξεχώριζε από την άλλη, και το
// ιστορικό του περιηγητή κατέγραφε την ίδια εγγραφή για κάθε σελίδα.
//
// **Γιατί εδώ και όχι στα κοινά συστατικά**, όπου ζουν οι υπόλοιποι hooks: το
// άρθρωμα δεν έχει καμία οπτική μορφή και δεν μπορεί να εμφανιστεί στη βιβλιοθήκη
// συστατικών — θα έμπαινε αναγκαστικά στις εξαιρέσεις της. Ο τίτλος του εγγράφου
// είναι καθολική κατάσταση του περιηγητή, όπως η συνεδρία, και εκεί ανήκει.

/**
 * Ο τίτλος της καρτέλας για μια σελίδα, ως **τιμή**.
 *
 * Χωριστή από την εγγραφή, γιατί είναι το μόνο σκέλος που μπορεί να ελεγχθεί: οι
 * δοκιμές της διαδικτυακής εφαρμογής τρέχουν **χωρίς περιβάλλον περιηγητή**, οπότε
 * δεν υπάρχει `document` να παρατηρηθεί. Το **δηλωμένο όριο** είναι ότι κανένας
 * αυτόματος έλεγχος δεν βλέπει την πραγματική καρτέλα· ελέγχεται η συμβολοσειρά
 * που θα γραφτεί σε αυτήν.
 *
 * Το όνομα της σελίδας μπαίνει **πρώτο** και ο σύντομος τίτλος της εφαρμογής
 * δεύτερος: η καρτέλα κόβει από τα δεξιά, οπότε ό,τι ξεχωρίζει τη μία καρτέλα από
 * την άλλη πρέπει να είναι στην αρχή.
 */
export function documentTitleOf(title) {
    const name = String(title ?? '').trim();
    // Χωρίς όνομα σελίδας μένει ο πλήρης τίτλος — ο ίδιος που δηλώνει το
    // `index.html`, ώστε η ταυτότητα να μην αλλάζει σε καμία στιγμή της φόρτωσης.
    if (!name) return APP.title;

    return `${name} · ${APP.shortTitle}`;
}

/** Γράφει τον τίτλο της καρτέλας όσο η σελίδα είναι στην οθόνη. */
export function useDocumentTitle(title) {
    useEffect(() => {
        document.title = documentTitleOf(title);
    }, [title]);
}

export default { documentTitleOf, useDocumentTitle };
